/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_O1_SubtitleInputs */

const en_visa_o1_subtitle = /** @type {(inputs: Visa_O1_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXTRAORDINARY ABILITY`)
};

const pt_visa_o1_subtitle = /** @type {(inputs: Visa_O1_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HABILIDADE EXTRAORDINÁRIA`)
};

const es_visa_o1_subtitle = /** @type {(inputs: Visa_O1_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HABILIDAD EXTRAORDINARIA`)
};

/**
* | output |
* | --- |
* | "EXTRAORDINARY ABILITY" |
*
* @param {Visa_O1_SubtitleInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_o1_subtitle = /** @type {((inputs?: Visa_O1_SubtitleInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_O1_SubtitleInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_o1_subtitle(inputs)
	if (locale === "es") return es_visa_o1_subtitle(inputs)
	return en_visa_o1_subtitle(inputs)
});